export function displayPrice(price: number): string {
    if (price % 100 === 0) {
        return price / 100 + ' €';
    }

    return (price / 100).toFixed(2) + ' €';
}
